import { Cancel, CheckCircle } from "@mui/icons-material";
import ViewForm from "../../components/viewCadastro/viewForm";
import { isEmpty } from "../../services/utils";
import { ConfigViewProps, mapDispatchToConfigProps, mapStateToConfigProps } from "./config.controll";
import { handleUpdateConfig } from "./config.dispatch";
import { Config } from "./config.model";
import Modal from "../../components/modal";
import { connect } from "react-redux";
import ViewCad from "../../view";
import { handleShowSelecionarCliente, ViewSelecionarCliente } from "../cliente/view/cliente.select";
import { handleSetShowSelectMeioPagModal, MeioPagSelectList } from "../meioPag/view/meiopg.select";
import { handleShowTabelaPrecoSelect, TabelaPrecoSelect } from "../settings/tabelaPreco/tabpreco.view";
import { useCallback, useEffect, useMemo } from "react";

interface SetDataInicialEstoqueProps extends ConfigViewProps {
    showModal: boolean,
    handleClose: () => any
    handleConfirme: () => any
}
function SetDataInicialEstoque(props: SetDataInicialEstoqueProps) {
    const { handleClose, showModal, handleConfirme } = props;
    const { row } = props.configState

    const View = ViewForm({
        row: row,
        contentForm: [
            {
                fieldName: "data_ini_estoque",
                type: "data",
                label: "Calcular Estoque a partir:",
                colunsXS: 12,
                colunsSM: 12,
                colunsMD: 12,
            }
        ],
        handleOnSubmit: function (values: Config): void {
            if (!isEmpty(values.data_ini_estoque)) {
                handleUpdateConfig(values);
                if (values.data_ini_estoque !== row.data_ini_estoque)
                    handleConfirme()
                handleClose();
            }
        },

        handleCancel: function (): void {
            throw new Error("Function not implemented.");
        },
        handleMutator: function ([value, field]: [any, any], state: any, { changeValue }: { changeValue: any; }): void {
            throw new Error("Function not implemented.");
        },
        formValidation: function (values: Config): void {
            let error: any = {}
            if (isEmpty(values.data_ini_estoque))
                error.data_ini_estoque = "Informe a data base para inicio do calculo do estoque."
            return error;
        },
        buttonActions: [
            {
                label: "Cancelar",
                color: "primary",
                type: "button",
                icon: <Cancel />,
                handleOnClick: () => handleClose()
            },

            {
                label: "Confirmar",
                color: "success",
                type: "submit",
                icon: <CheckCircle />
            }
        ]
    })

    return (
        <Modal
            open={showModal}
            handleClose={handleClose}
            component={View}
            width={"xs"}
            heigth={"auto"}
            handleOnKeyDown={() => { }}
        />
    )
}

export default connect(mapStateToConfigProps, mapDispatchToConfigProps)(SetDataInicialEstoque)


function ConvenioCad(props: ConfigViewProps) {
    const { configActions, configState } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = configState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = configActions

    console.log("Chamou ConvenioCad");
    useEffect(() => {
        console.log("useEffect ConvenioCad", row)
        get("@CONFIG");
    }, [])

    const formValidate = (values: Config) => {
        const errors: any = {}
        if (!values.cliente_default)
            errors.cliente_default._id = "Informe o cliente padrão"
        return errors
    }

    const handleUpdate = (value: Config) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        changeValue(state, field, () => value);
    }

    function SelectionCliente(propsCliente: any) {
        console.log("chamou SelectionCliente")
        return (
            <ViewSelecionarCliente
                handleConfirmar={(cliente) => {
                    console.log(cliente, propsCliente)
                }}
            />
        )
    }

    function SelectionMeioPag(propsMeioPag: any) {
        return (
            <MeioPagSelectList
                handleMeioPagSelect={(meiopag) => {
                    console.log(meiopag, propsMeioPag)
                    propsMeioPag.handleMutator(meiopag, "meio_pag_default");
                    handleSetShowSelectMeioPagModal(false)
                }}
            />
        )
    }

    var viewCad = new ViewCad({
        formTitle: "Configurações do Sistema",
        formSubtitle: "Informe os valores padrões do sitema e dados imutáveis",
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: false,
            title: "",
            onClick: () => { },
        },
        handleExcluir: () => { },
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: () => { },
        handleCloseView: () => { },
        
        handleMutator: handleMutator,
        contentForm: [
            {
                fieldName: "cliente_default.nome", label: "Cliente", type: "select-dialog", key: "cliente_default",
                colunsXS: 12, colunsSM: 12, colunsMD: 6, require: true,
                ViewSelecionarDialog: SelectionCliente,
                handleOnClickShow: () => handleShowSelecionarCliente(true),
                handleOnClickRemove: (v, f) => {
                    f && f({}, "cliente_default")
                },
                showButtonLimparSelectDialog: true,
            },
            {
                fieldName: "meio_pag_default.descricao", label: "Meio de Pagamento", type: "select-dialog", key: "meio_pag_default",
                colunsXS: 12, colunsSM: 12, colunsMD: 6, require: true,
                handleOnClickShow: () => handleSetShowSelectMeioPagModal(true),
                ViewSelecionarDialog:SelectionMeioPag,
                handleOnClickRemove: (v, f) => {
                    f && f({}, "meio_pag_default");
                },
                showButtonLimparSelectDialog: true,
            },
            {
                fieldName: "tabela_preco_default.descricao", label: "Tabela de Preço", type: "select-dialog", key: "tabela_preco_default",
                colunsXS: 12, colunsSM: 12, colunsMD: 6, require: true,
                handleOnClickShow: () => handleShowTabelaPrecoSelect(true),
                ViewSelecionarDialog: (propsDialog => {
                    return (
                        <TabelaPrecoSelect
                            handleTabelaPrecoSelect={(tabpreco) => {
                                console.log(tabpreco, propsDialog)
                                propsDialog.handleMutator(tabpreco, "tabela_preco_default")
                                handleShowTabelaPrecoSelect(false)
                            }}
                        />
                    )
                }),
                handleOnClickRemove: (v, f) => {
                    f && f({}, "tabela_preco_default");
                },
                showButtonLimparSelectDialog: true,
            },
            { fieldName: "qt_dig_cod_item", label: "Qtde. Dig. Cód. Item", tip: "Quantidade de digitos do código do item", type: "text", key: "qt_dig_cod_item", colunsXS: 3, colunsSM: 3, colunsMD: 3, require: true },
            { fieldName: "seq_cod_item", label: "Item Seq. Atual", tip: "Numero de incremento atual do cadastro do item", type: "text", key: "seq_cod_item", colunsXS: 3, colunsSM: 3, colunsMD: 3, disabled: true },
            { fieldName: "qt_dig_cod_mov", label: "Qtde. Dig. Cód. Mov.", tip: "Quantidade de digitos do código da movimentação", type: "text", key: "qt_dig_cod_mov", colunsXS: 3, colunsSM: 3, colunsMD: 3, require: true },
            { fieldName: "seq_cod_mov", label: "Mov. Seq. Atual", tip: "Numero de incremento atual do cadastro de movimentacões", type: "text", key: "seq_cod_mov", colunsXS: 3, colunsSM: 3, colunsMD: 3, disabled: true },
            { fieldName: "data_ini_estoque", label: "Data Estoque", tip: "Data inicio do controle do estoque", type: "data", key: "data_ini_estoque", colunsXS: 4, colunsSM: 4, colunsMD: 4, disabled: true },



        ],

    })

    return viewCad.render();
}

const ConvenioCadView = connect(mapStateToConfigProps, mapDispatchToConfigProps)(ConvenioCad)

export {
    ConvenioCadView
}